/* GlobifySIM – travel assistant
 *
 * Answers the questions travellers actually ask before buying an eSIM.
 * Works entirely in the browser: no API key, no server, no cost.
 *
 * Optional upgrade: set an endpoint in the theme settings and the widget
 * posts the conversation there instead, so you can put a real language
 * model behind it later without touching this file.
 */
(function () {
  "use strict";

  /* ---------------------------------------------------------- Werkzeuge */

  function flach(wert) {
    var t = String(wert == null ? "" : wert).toLowerCase();
    t = t.replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss");
    if (t.normalize) t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return t.replace(/[^a-z0-9]+/g, " ").replace(/^ +| +$/g, "");
  }

  function zahlAus(text) {
    var t = flach(text);
    var worte = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, twelve: 12, fourteen: 14, twenty: 20, thirty: 30 };
    var m = t.match(/(\d+)\s*(day|days|night|nights|week|weeks|month|months)?/);
    if (m) {
      var n = parseInt(m[1], 10);
      if (m[2] && m[2].indexOf("week") === 0) n *= 7;
      if (m[2] && m[2].indexOf("month") === 0) n *= 30;
      return n;
    }
    for (var w in worte) {
      if (t.indexOf(w) >= 0) {
        var f = t.indexOf("week") >= 0 ? 7 : (t.indexOf("month") >= 0 ? 30 : 1);
        return worte[w] * f;
      }
    }
    return null;
  }

  /* --------------------------------------------------------- Wissenbasis
     Jeder Eintrag: Stichwörter und die Antwort. Zum Erweitern einfach einen
     weiteren Block anhängen – die Reihenfolge spielt keine Rolle, es gewinnt
     der Eintrag mit den meisten Treffern. */

  var WISSEN = [
    {
      id: "greeting",
      worte: ["hello", "hi", "hey", "good morning", "good evening", "hallo"],
      antwort: function () {
        return {
          text: "Hi! I can help you pick the right eSIM. Tell me where you are going, how long you are away, or which phone you have.",
          chips: ["Where do you have coverage?", "How much data do I need?", "Will my phone work?"]
        };
      }
    },
    {
      id: "what_is_esim",
      worte: ["what is an esim", "what is esim", "explain esim", "how does esim work", "what does esim mean"],
      antwort: function () {
        return {
          text: "An eSIM is a SIM built into your phone. Instead of putting in a plastic card, you scan a QR code and a profile is loaded into your settings. Your phone then runs two lines at once: your own number for calls and texts, and our data plan for internet.",
          chips: ["Will my phone work?", "How do I install it?"]
        };
      }
    },
    {
      id: "install",
      worte: ["how do i install", "how to install", "setup", "set up", "activate", "activation", "qr code", "scan"],
      antwort: function () {
        return {
          text: "Three steps. 1) Buy the plan and we email you a QR code, usually within a few minutes. 2) At home on Wi-Fi, open your phone settings and scan the code to install the eSIM. 3) When you land, switch data roaming on for the eSIM and you are online. Do the scanning before you leave – you need internet for that part.",
          chips: ["When does my plan start?", "Will my phone work?"]
        };
      }
    },
    {
      id: "start",
      worte: ["when does it start", "when does my plan start", "validity", "expire", "countdown", "does the clock start"],
      antwort: function () {
        return {
          text: "The clock starts when the eSIM first connects to a network at your destination, not when you buy it. So you can buy days ahead and install it in your own time.",
          chips: ["How much data do I need?"]
        };
      }
    },
    {
      id: "number",
      worte: ["my number", "phone number", "keep my number", "calls", "sms", "text messages", "whatsapp still work", "can i call"],
      antwort: function () {
        return {
          text: "You keep your own number. Your normal SIM stays in the phone and still receives calls and texts. Our plans are data only, so calls over the mobile network are not included – but WhatsApp, FaceTime and similar apps work fine over the data connection. Tip: turn data roaming off on your own SIM so it cannot run up charges.",
          chips: ["How much data do I need?"]
        };
      }
    },
    {
      id: "hotspot",
      worte: ["hotspot", "tether", "tethering", "share data", "second phone", "laptop"],
      antwort: function () {
        return {
          text: "Yes, you can use the phone as a hotspot for a laptop, tablet or a travel companion on most plans. Just add a bit more data – sharing roughly doubles what you use.",
          chips: ["How much data do I need?"]
        };
      }
    },
    {
      id: "topup",
      worte: ["run out", "runs out", "top up", "topup", "add more data", "buy more", "extend"],
      antwort: function () {
        return {
          text: "Nothing bad happens: the connection simply stops and you are never charged extra. You can buy another pack at any time, and on most plans it is added to the eSIM you already installed – no second QR code to scan.",
          chips: ["Show me destinations"]
        };
      }
    },
    {
      id: "refund",
      worte: ["refund", "money back", "cancel", "return", "not working", "doesnt work", "does not work", "problem"],
      antwort: function () {
        return {
          text: "If you have not installed the profile yet, you can cancel and get your money back. If it is installed and something is genuinely broken, message our team with your order number, phone model and destination – we will look into it and sort it out.",
          chips: ["Talk to a human"]
        };
      }
    },
    {
      id: "delivery",
      worte: ["how long", "delivery", "when do i get", "shipping", "receive the code", "how fast"],
      antwort: function () {
        return {
          text: "There is nothing to ship. Your QR code arrives by email within 1-3 minutes of payment. If it has not arrived after 15 minutes, check your spam folder and then message us.",
          chips: ["Talk to a human"]
        };
      }
    },
    {
      id: "discount",
      worte: ["discount", "coupon", "promo", "voucher", "code", "cheaper", "deal", "offer"],
      antwort: function (kontext) {
        return {
          text: "Use code " + kontext.rabattcode + " at checkout for 5% off. It works on every destination and every data pack.",
          chips: ["Show me destinations"],
          code: kontext.rabattcode
        };
      }
    },
    {
      id: "coverage_general",
      worte: ["where do you have coverage", "which countries", "what countries", "coverage", "destinations", "do you cover"],
      antwort: function () {
        return {
          text: "We cover over 200 countries and regions. Type a country name and I will check it for you – or browse the full list on the page.",
          chips: ["Turkey", "Thailand", "United States", "Europe"],
          link: { text: "Browse all destinations", ziel: "#destinations" }
        };
      }
    },
    {
      id: "price",
      worte: ["how much does it cost", "price", "prices", "expensive", "cost"],
      antwort: function (kontext) {
        return {
          text: "Prices depend on the destination and how much data you want. Small packs start at about " + kontext.abpreis + ", and there are packs up to 50 GB. Tell me where you are going and I will point you at the right page.",
          chips: ["Show me destinations", "How much data do I need?"]
        };
      }
    },
    {
      id: "human",
      worte: ["human", "agent", "person", "support", "contact", "talk to someone", "email you"],
      antwort: function (kontext) {
        return {
          text: "Of course. Our team answers on chat and by email, usually the same day.",
          chips: [],
          link: kontext.wa ? { text: "Message us on WhatsApp", ziel: kontext.wa, extern: true }
                           : { text: "Go to the contact form", ziel: "#contact" }
        };
      }
    }
  ];

  /* ------------------------------------------------------------- Absicht */

  function bewerte(eingabe) {
    var q = flach(eingabe);
    var beste = null, bestpunkte = 0;
    WISSEN.forEach(function (eintrag) {
      var punkte = 0;
      eintrag.worte.forEach(function (w) {
        var wf = flach(w);
        if (q.indexOf(wf) >= 0) punkte += wf.split(" ").length * 2;
      });
      if (punkte > bestpunkte) { bestpunkte = punkte; beste = eintrag; }
    });
    return bestpunkte >= 2 ? beste : null;
  }

  function zielTreffer(eingabe) {
    if (!window.GSSuche) return null;
    var treffer = window.GSSuche.suchen(eingabe, 3);
    return treffer.length ? treffer : null;
  }

  function geraetTreffer(eingabe) {
    if (!window.GSCheck) return null;
    var treffer = window.GSCheck.suchen(eingabe, 2);
    return treffer.length ? treffer : null;
  }

  /* ------------------------------------------------------------- Aufbau */

  function aufbauen(wurzel) {
    var kontext = {
      rabattcode: wurzel.getAttribute("data-gs-code") || "GLOBIFY5",
      abpreis: wurzel.getAttribute("data-gs-abpreis") || "1 EUR",
      wa: wurzel.getAttribute("data-gs-wa") || "",
      ziellink: wurzel.getAttribute("data-gs-ziel-link") || "/products/",
      endpunkt: wurzel.getAttribute("data-gs-endpunkt") || ""
    };

    var knopf = wurzel.querySelector("[data-gs-bot-knopf]");
    var fenster = wurzel.querySelector("[data-gs-bot-fenster]");
    var verlauf = wurzel.querySelector("[data-gs-bot-verlauf]");
    var feld = wurzel.querySelector("[data-gs-bot-feld]");
    var senden = wurzel.querySelector("[data-gs-bot-senden]");
    var schliessen = wurzel.querySelector("[data-gs-bot-schliessen]");
    if (!knopf || !fenster || !verlauf || !feld) return;

    var zustand = { schritt: null, tage: null, offen: false };
    var gespraech = [];

    function blase(text, wer) {
      var d = document.createElement("div");
      d.className = "gs-bot__blase gs-bot__blase--" + wer;
      d.textContent = text;
      verlauf.appendChild(d);
      verlauf.scrollTop = verlauf.scrollHeight;
      return d;
    }

    function chips(liste) {
      if (!liste || !liste.length) return;
      var box = document.createElement("div");
      box.className = "gs-bot__chips";
      liste.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "gs-bot__chip";
        b.textContent = c;
        b.addEventListener("click", function () {
          box.remove();
          fragen(c);
        });
        box.appendChild(b);
      });
      verlauf.appendChild(box);
      verlauf.scrollTop = verlauf.scrollHeight;
    }

    function verweis(l) {
      if (!l) return;
      var a = document.createElement("a");
      a.className = "gs-bot__link";
      a.href = l.ziel;
      a.textContent = l.text;
      if (l.extern) { a.target = "_blank"; a.rel = "noopener"; }
      verlauf.appendChild(a);
      verlauf.scrollTop = verlauf.scrollHeight;
    }

    function antworten(a) {
      blase(a.text, "bot");
      verweis(a.link);
      chips(a.chips);
      gespraech.push({ role: "assistant", content: a.text });
    }

    /* ----- Mehrschrittige Datenberatung ----- */
    function datenBeratung(eingabe) {
      if (zustand.schritt === "tage") {
        var t = zahlAus(eingabe);
        if (!t) {
          return { text: "How many days will you be away? A number is enough, for example 10.", chips: ["5 days", "10 days", "2 weeks", "1 month"] };
        }
        zustand.tage = t;
        zustand.schritt = "profil";
        return {
          text: "Got it, " + t + " days. And how do you use your phone when you travel?",
          chips: ["Maps and messaging only", "Normal use", "Lots of video and music"]
        };
      }
      if (zustand.schritt === "profil") {
        var q = flach(eingabe);
        var profil = "mittel";
        if (q.indexOf("map") >= 0 || q.indexOf("messag") >= 0 || q.indexOf("light") >= 0 || q.indexOf("only") >= 0) profil = "leicht";
        if (q.indexOf("video") >= 0 || q.indexOf("music") >= 0 || q.indexOf("lot") >= 0 || q.indexOf("heavy") >= 0 || q.indexOf("stream") >= 0) profil = "stark";
        var e = window.GSRechner
          ? window.GSRechner.rechnen(zustand.tage, profil, false)
          : { empfehlung: Math.max(1, Math.round(zustand.tage * 0.7)) };
        zustand.schritt = null;
        return {
          text: "For " + zustand.tage + " days I would take a " + e.empfehlung + " GB pack. That already includes a bit of headroom, and you can always top up later without reinstalling anything.",
          chips: ["Show me destinations", "Will my phone work?"],
          link: { text: "Pick your destination", ziel: "#destinations" }
        };
      }
      zustand.schritt = "tage";
      var sofort = zahlAus(eingabe);
      if (sofort) return datenBeratung(String(sofort));
      return { text: "Happy to help. How many days will you be away?", chips: ["5 days", "10 days", "2 weeks", "1 month"] };
    }

    /* ----- Antwort zusammenstellen ----- */
    function denken(eingabe) {
      var q = flach(eingabe);

      if (zustand.schritt) return datenBeratung(eingabe);

      if (q.indexOf("how much data") >= 0 || q.indexOf("how many gb") >= 0 ||
          q.indexOf("how much gb") >= 0 || (q.indexOf("data") >= 0 && q.indexOf("need") >= 0)) {
        return datenBeratung(eingabe);
      }

      /* Gerätefrage erkennen */
      if (q.indexOf("iphone") >= 0 || q.indexOf("samsung") >= 0 || q.indexOf("galaxy") >= 0 ||
          q.indexOf("pixel") >= 0 || q.indexOf("xiaomi") >= 0 || q.indexOf("huawei") >= 0 ||
          q.indexOf("my phone") >= 0 || q.indexOf("compatible") >= 0 || q.indexOf("support esim") >= 0 ||
          q.indexOf("will my") >= 0) {
        var g = geraetTreffer(eingabe);
        if (g) {
          var eins = g[0];
          var satz;
          if (eins.status === "ja") satz = eins.marke + " " + eins.modell + " supports eSIM. ";
          else if (eins.status === "teilweise") satz = "Careful with the " + eins.marke + " " + eins.modell + ": only certain versions support eSIM. ";
          else satz = "The " + eins.marke + " " + eins.modell + " does not support eSIM. ";
          var h = eins.hinweis || "";
          if (h) satz += h + " ";
          if (eins.status !== "nein") satz += "It also has to be carrier-unlocked.";
          return {
            text: satz,
            chips: eins.status === "nein" ? ["Talk to a human"] : ["Show me destinations", "How much data do I need?"]
          };
        }
        return {
          text: "I do not have that exact model on my list. Check it on the phone itself: on iPhone go to Settings, General, About and look for an EID. On Android open the SIM manager or dial *#06#. If an EID shows up, you have eSIM.",
          chips: ["Talk to a human"],
          link: { text: "Open the device checker", ziel: "#device-check" }
        };
      }

      /* Wissenbasis */
      var eintrag = bewerte(eingabe);
      if (eintrag) return eintrag.antwort(kontext);

      /* Reiseziel erkennen */
      var ziele = zielTreffer(eingabe);
      if (ziele) {
        var z = ziele[0];
        var name = z.en || z.de;
        var url = kontext.ziellink + (z.handle || z.slug);
        return {
          text: "Yes, we cover " + name + " " + z.flagge + ". Data packs start small and go up to 50 GB, and the code " + kontext.rabattcode + " takes 5% off.",
          link: { text: "See plans for " + name, ziel: url },
          chips: ["How much data do I need?", "Will my phone work?"]
        };
      }

      /* Nichts erkannt */
      return {
        text: "I did not quite catch that. I can help with destinations, how much data you need, whether your phone works, setup, and orders. For anything else our team is happy to help.",
        chips: ["Where do you have coverage?", "How much data do I need?", "Talk to a human"]
      };
    }

    /* ----- Optionaler Server mit Sprachmodell ----- */
    function serverFragen(eingabe) {
      var warte = blase("…", "bot");
      fetch(kontext.endpunkt, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: gespraech.concat([{ role: "user", content: eingabe }]) })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          warte.remove();
          antworten({ text: d.reply || d.text || "Sorry, something went wrong.", chips: [] });
        })
        .catch(function () {
          warte.remove();
          antworten(denken(eingabe));
        });
    }

    function fragen(eingabe) {
      var text = String(eingabe || "").trim();
      if (!text) return;
      blase(text, "ich");
      gespraech.push({ role: "user", content: text });
      feld.value = "";
      if (kontext.endpunkt) { serverFragen(text); return; }
      window.setTimeout(function () { antworten(denken(text)); }, 260);
    }

    function oeffnen() {
      zustand.offen = true;
      fenster.classList.add("ist-offen");
      knopf.setAttribute("aria-expanded", "true");
      feld.focus();
      if (!verlauf.childNodes.length) {
        antworten({
          text: wurzel.getAttribute("data-gs-gruss") ||
            "Hi! I help travellers pick the right eSIM. Where are you going?",
          chips: ["Where do you have coverage?", "How much data do I need?", "Will my phone work?"]
        });
      }
    }

    function zu() {
      zustand.offen = false;
      fenster.classList.remove("ist-offen");
      knopf.setAttribute("aria-expanded", "false");
    }

    knopf.addEventListener("click", function () { zustand.offen ? zu() : oeffnen(); });
    if (schliessen) schliessen.addEventListener("click", zu);
    if (senden) senden.addEventListener("click", function (e) { e.preventDefault(); fragen(feld.value); });
    feld.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); fragen(feld.value); }
      if (e.key === "Escape") zu();
    });
  }

  window.GSAssistent = { flach: flach, zahlAus: zahlAus, WISSEN: WISSEN };

  document.addEventListener("DOMContentLoaded", function () {
    var alle = document.querySelectorAll("[data-gs-bot]");
    for (var i = 0; i < alle.length; i++) aufbauen(alle[i]);
  });
})();
